import { Directive, ElementRef, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[data-scroll-into-view]',
})
export class ScrollIntoViewDirective implements AfterViewInit {
  private readonly MOBILE_BREAKPOINT = 768; // Standard mobile breakpoint
  private readonly MOBILE_OFFSET = 70;

  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    // Use setTimeout to ensure the element is fully rendered
    setTimeout(() => {
      const isMobile = window.innerWidth <= this.MOBILE_BREAKPOINT;
      const elementPosition = this.el.nativeElement.getBoundingClientRect().top;
      const offsetPosition =
        elementPosition +
        window.pageYOffset -
        (isMobile ? this.MOBILE_OFFSET : 0);

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    });
  }
}
